import React from 'react';
import PropTypes from 'prop-types';
import { useSelected, useFocused } from 'slate-react';

const ImageElement = ({ attributes, children, element }) => {
	const selected = useSelected();
	const focused = useFocused();
	return (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<div {...attributes}>
			{children}
			<img
				alt="Attachment"
				src={element.url}
				style={{
					display: 'block',
					maxWidth: '100%',
					maxHeight: '20em',
					boxShadow: selected && focused ? '0 0 0 2px blue;' : 'none'
				}}
			/>
		</div>
	);
};

ImageElement.propTypes = {
	attributes: PropTypes.object,
	children: PropTypes.element,
	element: PropTypes.shape({
		url: PropTypes.string
	})
};

export default ImageElement;
